/**
 * Generated by orval v6.28.2 🍺
 * Do not edit manually.
 * Maybern
 * Maybern API
 * OpenAPI spec version: 0.0.0
 */
import {
  z as zod
} from 'zod'

/**
 * Creates a customer
 */
export const customerCreateQueryParams = zod.object({
  "create_transaction_codes": zod.boolean().optional()
})

export const customerCreateBodyAnnotationsSetMin = 2;
export const customerCreateBodyAnnotationsSetMax = 2;

export const customerCreateBody = zod.object({
  "annotations_set": zod.array(zod.array(zod.any()).min(customerCreateBodyAnnotationsSetMin).max(customerCreateBodyAnnotationsSetMax)).optional(),"name": zod.string().min(1),"domain": zod.string().min(1),"created_at": zod.string().datetime().or(zod.union([zod.null(), zod.literal("")])).optional(),"web_domain": zod.string().or(zod.union([zod.null(), zod.literal("")])).optional(),"id": zod.string().min(1).or(zod.union([zod.null(), zod.literal("")])).optional(),"enable_delete_protection": zod.boolean().optional(),"is_maybern_customer": zod.boolean().optional(),"state": zod.enum(['draft', 'active', 'archived', ""]).optional()
})

/**
 * Deletes customer user relation data. This will DELETE the users association with the customer!!!
 */
export const internalCustomerUserRelationDestroyParams = zod.object({
  "customerId": zod.string(),"userId": zod.string()
})

/**
 * Gets customer data for a specific customer.
 */
export const customerRetrieveParams = zod.object({
  "id": zod.string()
})

export const customerRetrieveResponseAnnotationsSetMin = 2;
export const customerRetrieveResponseAnnotationsSetMax = 2;

export const customerRetrieveResponse = zod.object({
  "annotations_set": zod.array(zod.array(zod.any()).min(customerRetrieveResponseAnnotationsSetMin).max(customerRetrieveResponseAnnotationsSetMax)).optional(),"name": zod.string().min(1),"domain": zod.string().min(1),"created_at": zod.string().datetime().or(zod.union([zod.null(), zod.literal("")])).optional(),"web_domain": zod.string().or(zod.union([zod.null(), zod.literal("")])).optional(),"id": zod.string().min(1).or(zod.union([zod.null(), zod.literal("")])).optional(),"enable_delete_protection": zod.boolean().optional(),"is_maybern_customer": zod.boolean().optional(),"state": zod.enum(['draft', 'active', 'archived', ""]).optional()
})

/**
 * Updates customer data.
 */
export const customerUpdateParams = zod.object({
  "id": zod.string()
})

export const customerUpdateBodyAnnotationsSetMin = 2;
export const customerUpdateBodyAnnotationsSetMax = 2;

export const customerUpdateBody = zod.object({
  "annotations_set": zod.array(zod.array(zod.any()).min(customerUpdateBodyAnnotationsSetMin).max(customerUpdateBodyAnnotationsSetMax)).optional(),"name": zod.string().min(1),"domain": zod.string().min(1),"created_at": zod.string().datetime().or(zod.union([zod.null(), zod.literal("")])).optional(),"web_domain": zod.string().or(zod.union([zod.null(), zod.literal("")])).optional(),"id": zod.string().min(1).or(zod.union([zod.null(), zod.literal("")])).optional(),"enable_delete_protection": zod.boolean().optional(),"is_maybern_customer": zod.boolean().optional(),"state": zod.enum(['draft', 'active', 'archived', ""]).optional()
})

export const customerUpdateResponseAnnotationsSetMin = 2;
export const customerUpdateResponseAnnotationsSetMax = 2;

export const customerUpdateResponse = zod.object({
  "annotations_set": zod.array(zod.array(zod.any()).min(customerUpdateResponseAnnotationsSetMin).max(customerUpdateResponseAnnotationsSetMax)).optional(),"name": zod.string().min(1),"domain": zod.string().min(1),"created_at": zod.string().datetime().or(zod.union([zod.null(), zod.literal("")])).optional(),"web_domain": zod.string().or(zod.union([zod.null(), zod.literal("")])).optional(),"id": zod.string().min(1).or(zod.union([zod.null(), zod.literal("")])).optional(),"enable_delete_protection": zod.boolean().optional(),"is_maybern_customer": zod.boolean().optional(),"state": zod.enum(['draft', 'active', 'archived', ""]).optional()
})

/**
 * Deletes customer data. This will DELETE all underlying data!!
 */
export const customerDestroyParams = zod.object({
  "id": zod.string()
})

